export const environment = {
  production: false,
  apiUrl: 'api/ch',
  // eslint-disable-next-line
  version: require('../../package.json').version,
  isSecure: true,
  cognitoConf: {
    region: 'eu-central-1',
    apiVersion: '2016-04-18',
    accessKeyId: 'AKIA33FGRLTR3MR4N5OS',
    secretAccessKey: '0kCW1TUufZnU/zCxkr/lbdXbSe2M3qNGtrmFOYwUGxG+d9ftfkc7u',
    clientSecret: '6kj4mo01mb5dhdl5n1lacidfkum4bau2m7t03bu4achdqrk1rn0',
    clientId: '7gkvirjfvhga5irajq32n1qi1r',
    userPoolId: 'eu-central-1_eJ1ivs8Ew',
  },
};
